import Modal from "react-modal";
import PropTypes from "prop-types";

const CustomModal = ({
  isOpen,
  onRequestClose,
  className,
  children,
  contentLabel = "Modal",
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className={className}
      contentLabel={contentLabel}
      ariaHideApp={false}
    >
      {children}
    </Modal>
  );
};

CustomModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  className: PropTypes.string,
  contentLabel: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default CustomModal;
